/**
 * TeamSystem Impact - Settings Router
 * Sub-routes: info, users, connections, sustainability, teams
 */

import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AboutPage } from './AboutPage';
import { SustainablePlatformPage } from './SustainablePlatformPage';
import { UserManagementPage } from './UserManagementPage';
import { ConnectionsPage } from './ConnectionsPage';
import { YearManagementPage } from './YearManagementPage';

const TeamsSettingsPage = lazy(() => import('./pages/TeamsSettingsPage'));

function Loading() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
      <CircularProgress />
    </Box>
  );
}

export function SettingsRouter() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route index element={<Navigate to="info" replace />} />
        <Route path="info" element={<AboutPage />} />
        <Route path="year-management" element={<YearManagementPage />} />
        <Route path="users" element={<UserManagementPage />} />
        <Route path="connections" element={<ConnectionsPage />} />
        <Route path="sustainability" element={<SustainablePlatformPage />} />
        <Route path="teams" element={<TeamsSettingsPage />} />
        {/* Backward compat: old /settings/general → /settings/info */}
        <Route path="general" element={<Navigate to="/settings/info" replace />} />
        <Route path="*" element={<Navigate to="info" replace />} />
      </Routes>
    </Suspense>
  );
}
